import { Component, OnChanges, SimpleChanges } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { InputComponent } from '../base/input.component';
import { dateString } from '../../core/utils';

@Component({
    standalone: true,
    imports: [CommonModule, FormsModule],
    selector: 'wd-date',
    templateUrl: 'date-view.component.html',
    styleUrls: ['../styles/view.component.css', '../styles/view-only.component.css'],
})
export class DateViewComponent extends InputComponent<string> implements OnChanges {
	datum = '';

	constructor() {
		super();
	}

	override ngOnChanges(changes: SimpleChanges): void {
		this.datum = dateString(this.model);
	}
}
